import styled from 'styled-components';
import { Link } from 'react-router-dom';
import AppCSS from '../../../utils/styled';
import { ReactComponent as AngleDownIcon } from '../../../assets/icons/icon-angle-down.svg';

export const Components = {
  Wrapper: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
  `,
  ParentButton: styled.button<{ $isCollapsed?: boolean }>`
    display: flex;
    align-items: center;
    justify-content: ${(p) => (p.$isCollapsed ? 'center' : 'flex-start')};
    width: 100%;
    margin: 16px 0;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    text-align: left;

    &:focus-visible {
      outline: 2px solid ${AppCSS.colors.blues.primary};
      outline-offset: 2px;
    }
  `,
  IconWrapper: styled.div<{ $isActive?: boolean; $isCollapsed?: boolean }>`
    margin-right: ${(p) => (p.$isCollapsed ? 0 : 12)}px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background-color: ${(p) => (p.$isActive ? AppCSS.colors.white : 'transparent')};
    ${AppCSS.radiuses.default};
    transition: background-color 0.15s ease;
    button:hover > & {
      background-color: ${(p) => (p.$isActive ? AppCSS.colors.white : 'rgba(255, 255, 255, 0.12)')};
    }
  `,
  Label: styled.span<{ $isActive?: boolean }>`
    flex: 1;
    ${({ $isActive }) => ($isActive ? AppCSS.fonts.label14Medium : AppCSS.fonts.label14Regular)};
    color: ${AppCSS.colors.white};
  `,
  Chevron: styled(AngleDownIcon)<{ $isExpanded: boolean }>`
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    transition: transform 0.2s ease;
    transform: rotate(${(p) => (p.$isExpanded ? 180 : 0)}deg);

    path {
      fill: ${AppCSS.colors.white};
    }
  `,
  SubMenu: styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-bottom: 8px;
  `,
  GroupTitle: styled.span`
    ${AppCSS.fonts.label10Bold};
    color: ${AppCSS.colors.blues.gray};
    text-transform: uppercase;
    letter-spacing: 0.08em;
    padding: 10px 12px 4px 52px;
  `,
  SubItem: styled(Link)<{ $isActive: boolean }>`
    display: block;
    padding: 6px 12px 6px 49px;
    border-left: 3px solid ${({ $isActive }) => ($isActive ? AppCSS.colors.blues.primary : 'transparent')};
    ${AppCSS.radiuses.small};
    background-color: ${({ $isActive }) => ($isActive ? 'rgba(255, 255, 255, 0.1)' : 'transparent')};
    ${({ $isActive }) => ($isActive ? AppCSS.fonts.label14Medium : AppCSS.fonts.label14Regular)};
    color: ${({ $isActive }) => ($isActive ? AppCSS.colors.white : AppCSS.colors.greys.light)};
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      background-color: rgba(255, 255, 255, 0.08);
      color: ${AppCSS.colors.white};
    }

    &:focus-visible {
      outline: 2px solid ${AppCSS.colors.blues.primary};
      outline-offset: 1px;
    }
  `,
};
